/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListUserPreferencesParams,
  PaginatedUserPreferences,
  SchemaValidationErrorResponse,
  UserPreference,
  UserPreferenceRequestInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of User Preferences
 */
export const listUserPreferences = (
    params?: MaybeRefOrGetter<ListUserPreferencesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedUserPreferences>(
      {url: `/user_preferences`, method: 'GET',
        params, signal
    },
      );
    }




export const getListUserPreferencesQueryKey = (params?: MaybeRefOrGetter<ListUserPreferencesParams>,) => {
    return [
    'user_preferences', ...(params ? [params] : [])
    ] as const;
    }


export const getListUserPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof listUserPreferences>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListUserPreferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListUserPreferencesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserPreferences>>> = ({ signal }) => listUserPreferences(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData>
}

export type ListUserPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listUserPreferences>>>
export type ListUserPreferencesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of User Preferences
 */

export function useListUserPreferences<TData = Awaited<ReturnType<typeof listUserPreferences>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListUserPreferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserPreferencesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update/Create User Preference
 */
export const updateUserPreference = (
    userPreferenceRequestInput: MaybeRefOrGetter<UserPreferenceRequestInput>,
 signal?: AbortSignal
) => {
      userPreferenceRequestInput = toValue(userPreferenceRequestInput);

      return axiosClient<UserPreference>(
      {url: `/user_preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userPreferenceRequestInput, signal
    },
      );
    }




export const getUpdateUserPreferenceMutationKey = () => ['updateUserPreference'] as const;

export const getUpdateUserPreferenceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,UpdateUserPreferenceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,UpdateUserPreferenceMutationVariables, TContext> => {

const mutationKey = getUpdateUserPreferenceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserPreference>>, UpdateUserPreferenceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateUserPreference(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserPreference>>>
    export type UpdateUserPreferenceMutationBody = UserPreferenceRequestInput
    export type UpdateUserPreferenceMutationError = ErrorType<void>
    export type UpdateUserPreferenceMutationVariables = {data: UserPreferenceRequestInput}

    /**
 * @summary Update/Create User Preference
 */
export const useUpdateUserPreference = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,UpdateUserPreferenceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserPreference>>,
        TError,
        UpdateUserPreferenceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserPreferenceMutationOptions(options), queryClient);
    }
